import { render, staticRenderFns } from "./AddTruck.vue?vue&type=template&id=477822dc&scoped=true&"
import script from "./AddTruck.vue?vue&type=script&lang=js&"
export * from "./AddTruck.vue?vue&type=script&lang=js&"
import style0 from "./AddTruck.vue?vue&type=style&index=0&id=477822dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477822dc",
  null
  
)

export default component.exports